import type {
  AuthenticatedUser,
  ChangePasswordPayload,
  ForgotPasswordPayload,
  LoginCredentials,
} from "../../models/User";
import type IAuthRepository from "../../ports/auth/IAuthRepository";

type TokenStore = {
  save: (token: string) => void;
  clear: () => void;
};

class Authentication {
  constructor(
    private repository: IAuthRepository,
    private tokenStore: TokenStore,
  ) {}

  public async login(
    credentials: LoginCredentials,
  ): Promise<AuthenticatedUser | null> {
    const response = await this.repository.login(credentials);
    this.tokenStore.save(response.token);

    return response.user ?? null;
  }

  public async fetchCurrentUser(): Promise<AuthenticatedUser> {
    return this.repository.fetchCurrentUser();
  }

  public async logout(): Promise<void> {
    try {
      await this.repository.logout();
    } finally {
      this.tokenStore.clear();
    }
  }

  public async forgotPassword(
    payload: ForgotPasswordPayload,
  ): Promise<string | null> {
    return this.repository.forgotPassword(payload);
  }

  public async changePassword(
    payload: ChangePasswordPayload,
  ): Promise<string | null> {
    return this.repository.changePassword(payload);
  }
}

export default Authentication;
